import CnCardView from './cn-card-view';
export var CnCard = CnCardView;
export * from './types/main';
